export default {
  CONFIRM_ADMIN_INVITATION_REQUEST: 'CONFIRM_ADMIN_INVITATION_REQUEST',
  CONFIRM_ADMIN_INVITATION_SUCCESS: 'CONFIRM_ADMIN_INVITATION_SUCCESS',
  CONFIRM_ADMIN_INVITATION_FAILURE: 'CONFIRM_ADMIN_INVITATION_FAILURE',
  UPDATE_INVITED_SITE_ADMIN_DETAILS: 'UPDATE_INVITED_SITE_ADMIN_DETAILS'
}
